import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/Layout";
import { PageMeta } from "./components/PageMeta";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Industries from "./pages/Industries";
import IndustryDetail from "./pages/IndustryDetail";
import WhyChoose from "./pages/WhyChoose";
import Contact from "./pages/Contact";
import SEOLandingPage from "./pages/SEOLandingPage";
import NotFound from "./pages/NotFound";

// Router-independent page tree. Also rendered at build time by scripts/prerender.js.
export function AppRoutes() {
  return (
    <Layout>
      <PageMeta />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceId" element={<ServiceDetail />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/industries/:industryId" element={<IndustryDetail />} />
        <Route path="/why-flexitech" element={<WhyChoose />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/seo/:pageId" element={<SEOLandingPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
